
let Weight = {}

Weight.PoundAndOnce = (value) => {
    const Pound = Math.floor(value);
    const Ounces = (value - Pound) * 16;
    return {Pound, Ounces : Ounces.toFixed(0)}
}

Weight.PoundToPoundOunce = (pounds, ounces) => {
    const ouncesInPounds = ounces / 16; 
    const totalWeightInPounds = Number(pounds) + Number(ouncesInPounds);
    return totalWeightInPounds;
}



export default Weight
